import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { RouterModule } from '@angular/router';
import { JobDetailPreviewComponent } from '../job-detail-preview/job-detail-preview.component';
import { PunchPatternPreviewComponent } from '../punch-pattern-preview/punch-pattern-preview.component';
import { CoilTypePreviewComponent } from '../coil-type-preview/coil-type-preview.component';
import { ToolingPreviewComponent } from '../tooling-preview/tooling-preview.component';

@Component({
  selector: 'app-link-helper',
  templateUrl: './link-helper.component.html',
  styleUrls: ['./link-helper.component.scss'],
  imports: [
    RouterModule,
    JobDetailPreviewComponent,
    PunchPatternPreviewComponent,
    CoilTypePreviewComponent,
    ToolingPreviewComponent
],
})
export class LinkHelperComponent implements OnChanges {
  @Input() hideType = false;
  @Input() documentId = '';
  @Input() labelTxt = '';
  /**
   * Set by list pages that keep their filter in the URL, so the detail page can hand
   * that filter back when its back arrow is used. Off everywhere else — a link out of
   * a report shouldn't drag the report's date range onto a detail page.
   */
  @Input() preserveQueryParams = false;

  docType: string = '';
  docId: string = '';
  href: string = '';
  knownType: boolean = false;
  idFound: boolean = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.documentId) {
      // so far, I think these are all coming from punch patterns. It might be better to handle this in the link-helper-cell component. For now, just ignore them.
      return;
    }
    let docIdArray = this.documentId.split('/');
    this.docType = docIdArray[0];
    if (docIdArray.length === 1) {
      console.error(`Invalid documentId:${this.documentId}`);
      this.labelTxt = 'Invalid documentId';
      return;
    }
    // Ids can contain slashes themselves (tooling codes such as "6X2-1/8X2-3/8 ZEE"), so
    // everything past the type prefix is the id. setupsChange reads the parts it needs
    // straight off docIdArray below.
    this.docId = docIdArray.slice(1).join('/');
    this.idFound = Boolean(this.docId) ? !(this.docId === 'null' || this.docId === '0') : false;
    switch (this.docType) {
      case 'JobDetail':
        this.knownType = true;
        break;
      case 'Coil':
        this.knownType = true;
        break;
      case 'PunchPattern':
        this.knownType = true;
        break;
      case 'ToolingDef':
        this.knownType = true;
        break;
      case 'Material':
        if (this.docId === 'NO COIL MATCH') {
          this.idFound = false;
        }
        this.knownType = true;
        break;
      case 'setupsChange':
        if (docIdArray.length === 3) {
          this.knownType = true;
          this.href = `/machines/xl200/${docIdArray[1]}?tab=setups&snapshot=${docIdArray[2]}`;
        } else {
          console.error(`Invalid documentId:${this.documentId}`);
        }
        break;
      default:
        console.log(`Unknown type:${this.docType}`);
        break;
    }
  }
}
